// @flow

import React from 'react'
import styled from 'styled-components'
import { FloatingActionButton } from 'material-ui'

import Header, { height as headerHeight } from './Header'

const Wrapper = styled.div``

const FAB = styled(FloatingActionButton)`
  position: fixed;
  right: 24px;
  bottom: 24px;
`

export default ({ children, className, fab, onFab, ...props }) => {
  return (
    <Wrapper className={className}>
      <Header {...props} />
      {children}
      {fab && (
        <FAB secondary onClick={onFab}>
          {fab}
        </FAB>
      )}
    </Wrapper>
  )
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: flex-start;
`



// WEBPACK FOOTER //
// ./src/elements/Page.js